import { Component, OnInit } from '@angular/core';
import { BadaService } from 'src/app/services/bada.service';

@Component({
  selector: 'app-plate-search',
  templateUrl: './plate-search.component.html',
  styleUrls: ['./plate-search.component.css']
})
export class PlateSearchComponent implements OnInit {
  vehiclePlateToSearch: string;

  constructor(private badaService: BadaService) { }

  ngOnInit(): void { }

  /**
   * Interrogazione nella banca dati per targa
   */
  searchVehicleByPlate() {
    this.badaService.getInfocarDaTargaTest(this.vehiclePlateToSearch).subscribe(res => {
    }, err => {
      console.error(err);
    })
  }

}
